import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN NavTabs variants using HEN Design System tokens.
 *
 * - `default` — card-style tabs for dashboard / hub subsection navigation.
 * - `underline` — horizontal link tabs for in-page anchor navigation.
 */
export const navTabsListVariants = cva(
  'group-data-[orientation=horizontal]/tabs:h-auto w-full items-stretch justify-start',
  {
    variants: {
      variant: {
        default: 'flex-wrap gap-2',
        underline:
          'flex-nowrap gap-lg overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden bg-transparent p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export const navTabsTriggerVariants = cva('inline-flex', {
  variants: {
    variant: {
      default:
        'min-h-[56px] min-w-[120px] max-w-[220px] items-center gap-2 rounded-[8px] border border-neutral-200 p-3 font-body text-b5 font-normal text-black no-underline data-[state=active]:bg-neutral-50 data-[state=inactive]:bg-white data-[state=inactive]:hover:bg-neutral-50/50',
      underline:
        'shrink-0 -mb-px pb-sm px-xs whitespace-nowrap rounded-none border-0 border-b-2 bg-transparent p-0 font-body text-sm font-semibold shadow-none data-[state=active]:bg-transparent data-[state=inactive]:bg-transparent data-[state=active]:border-primary-700 data-[state=active]:text-neutral-900 data-[state=inactive]:border-transparent data-[state=inactive]:text-neutral-500 data-[state=inactive]:hover:border-neutral-100 data-[state=inactive]:hover:text-neutral-900',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const navTabsLabelVariants = cva('min-w-0 text-left leading-4', {
  variants: {
    variant: {
      default:
        'break-words text-wrap [margin-block-end:var(--paragraph-spacing-b5,0)]',
      underline: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type NavTabsVariantProps = VariantProps<typeof navTabsListVariants>;
